import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { MdAdd } from "react-icons/md";
import { useUser } from "../../context/UserContext";
import { openUpgradeModal } from "../../lib/upgradeModal";
import { hasProductsToAdd } from "../../lib/productAccess";
import PRODUCTS from "../../pages/SignUpPage/products";
import "./AddBanksPill.scss";

/** Routes where a question session is running, so nothing should tempt the user away. */
export const PILL_HIDDEN_PATHS = ["/practice", "/assignment"];

/** Top bar shortcut for paying users to buy question banks they don't have yet. */
const AddBanksPill = () => {
  const { user, accessStatus, enrolments } = useUser();
  const { pathname } = useLocation();
  const canAddBanks = useMemo(() => hasProductsToAdd(PRODUCTS, enrolments), [enrolments]);

  const isInSession = PILL_HIDDEN_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`));
  if (user?.type !== "student" || accessStatus !== "active" || isInSession || !canAddBanks) {
    return null;
  }

  return (
    <button type="button" className="add-banks-pill" onClick={openUpgradeModal} aria-label="Add question banks">
      <MdAdd className="add-banks-pill__icon" aria-hidden="true" />
      <span className="add-banks-pill__text">Add question banks</span>
    </button>
  );
};

export default AddBanksPill;
